<template>
    <div>
        <CallAlert ref="callAlert"></CallAlert>
        <modal :show.sync="modals.sendApply"
               body-classes="p-0"
               modal-classes="modal-dialog-centered">
            <card type="secondary" shadow
                  header-classes="bg-white pb-5"
                  body-classes="px-lg-5 py-lg-5"
                  class="border-0">
                <template>
                    <div class="text-muted text-center mb-3">
                        {{ modals.title }}
                    </div>
                    <!--
                <div class="btn-wrapper text-center">
                    <base-button type="neutral">
                        <img slot="icon" src="img/icons/common/github.svg">
                        Github
                    </base-button>

                    <base-button type="neutral">
                        <img slot="icon" src="img/icons/common/google.svg">
                        Google
                    </base-button>
                </div>
                 -->
                </template>
                <template>
                    <div class="text-center text-muted mb-4">
                        <!--<small>Or sign in with credentials</small>-->
                    </div>
                    <form role="form" id="modalForm">
                        <base-input class="mt-3"
                                    alternative
                                    placeholder="Название предприятия"
                                    addon-left-icon="fa fa-building-o"
                                    v-model="form.company"
                                    @keydown.space.prevent
                                    v-if="modals.title == 'Узнать цену'">
                        </base-input>
                        <base-input class="mt-3"
                                    alternative
                                    :placeholder="placeholder.name"
                                    addon-left-icon="ni ni-user-run"
                                    v-model="form.name" :valid="validation"
                                    @keydown.space.prevent>
                        </base-input>
                        <div class="form-row m-0">
                            <base-input alternative
                                        placeholder="Телефон"
                                        v-model="form.phone"
                                        addon-left-icon="fa fa-phone"
                                        @keydown.space.prevent
                                        class="col p-0 mr-1">
                            </base-input>
                            <base-input alternative
                                        :placeholder="placeholder.email"
                                        :valid="validationEmail"
                                        v-model="form.email"
                                        addon-left-icon="ni ni-email-83"
                                        @keydown.space.prevent
                                        class="col p-0 ml-1">
                            </base-input>
                        </div>
                        <base-input class="mb-4">
                            <textarea class="form-control form-control-alternative" name="name" rows="4"
                                      cols="80" placeholder="Комментарий..."
                                      v-model="form.message"></textarea>
                        </base-input>
                        <base-button type="default" round block
                                     @click="sendMessage(modals.title + ': ' + modals.info)">
                            Отправить
                        </base-button>

                    </form>
                </template>
            </card>
        </modal>
    </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
import CallAlert from "@/components/CallAlert.vue";
export default {
  name: "CallModal",
  components: {
      Modal,
      CallAlert
  },
  data() {
    return {
        modals: {
            sendApply: false,
            title: '',
            info: ''
        },
        form: {
            company: '',
            name: '',
            phone: '',
            email: '',
            message: ''
        },
        placeholder: {
            name: 'ФИО',
            email: 'Email'
        },
        validation: null,
        validationEmail: null,
    };
  },
  methods: {
      sendMessage(title) {
        this.validation = null;
        this.validationEmail = null;

        if (this.form.name == '') {
            this.placeholder.name = 'Имя должно быть заполнено';
            this.validation = false;
        }
        if (this.form.email == '') {
            this.placeholder.email = 'Email';
            this.validationEmail = false;
        }
        if ((this.form.name != '') 
            && (this.form.email != '')) {
            var params = {
                params: {
                    title: title,
                    company: this.form.company,
                    name: this.form.name,
                    phone: this.form.phone,
                    email: this.form.email,
                    message: this.form.message,
                }
            };
            this.$axios
                .get('/rest/message/', params)
                .then(response => {
                    this.$refs.callAlert.showAlert();
                    this.form.name = '';
                    this.form.company = '';
                    this.form.phone = '';
                    this.form.email = '';
                    this.form.message = '';
                    this.placeholder.name = 'Имя';
                    this.placeholder.email = 'Email';
                    this.modals.sendApply = false;
                });
        }
      }
  }
};
</script>
<style>
    #modalForm .form-control {
        font-size: 0.8rem;
    }
</style>
